module.exports = __webpack_public_path__ + "img/car_00032.93de764a.jpg";